<template>
<Dashboard />
</template>

<script>
import Dashboard from "../components/DashboardComponent";

export default {
    components: {
        Dashboard,
    },
};
</script>
